<template>
  <div class="header">
    <el-icon @click="goBack"><ArrowLeft /></el-icon>

    <p>{{props.title}}</p>
  </div>
</template>

<script setup>
import { ArrowLeft } from "@element-plus/icons-vue";

// import { nextTick, onMounted, reactive, ref, watch } from "vue";
import {
  nextTick,
  onMounted,
  reactive,
  ref,
  watch,
  toRefs,
  provide,
  inject,
} from "vue";
// import { SwitchButton } from "@element-plus/icons-vue";
// // import { Upload} from "@element-plus/icons-vue";
// import { Top } from "@element-plus/icons-vue";
// import { ElMessage } from "element-plus";
import lastBar from "@/components/lastBar/index.vue";

import { ElMessageBox } from "element-plus";
// import type { DrawerProps } from 'element-plus'

import { useRouter, useRoute } from "vue-router";

import { useStore } from "vuex";

import { getConfig } from "@/api/list/index.js";

const store = useStore();

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  // // zoom: 1,
  // login:'登录',
  // register:'注册',
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {},

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  configObj: {},

  active: "",
  activeIndex: "1", // 这里不能写空字符串，因为它绑定给了default-active（页面加载时默认激活菜单的 index）应该是index下标不能为空字符串吧

  drawer2: false,
  direction: "ltr",
});

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
  // 是否跳转到外部页面
  outPage: {
    type: Boolean,
    default: false,
  },
});


// // 依赖注入
// provide("goOutReomveData", fn);
// // 依赖注入
// provide("configObj", toRefs(mydata).configObj);

// const configObj = inject("configObj");

function fn() {
  mydata.userInfo = null;
}

const { circleUrl, sizeList } = toRefs(mydata);




//返回上一页
function goBack() {
  history.back();
}



// mydata.adminName = localStorage.getItem('adminName') ? localStorage.getItem('adminName') : ''

// const layout_router_view = ref(null);

// onMounted(() => {
//   nextTick(() => {
//     // 电脑屏幕宽度
//     let screenWidth = window.screen.width;
//     // 设计图的宽度
//     let uiWidth = 1920;
//     // 计算出应该缩放的比例，四舍五入保留一位小数
//     let ratio = Number((screenWidth / uiWidth).toFixed(1));
//     // 进行样式缩放
//     // console.log("111111111111", layout_router_view);
//     layout_router_view.value.$el.style.zoom = ratio;
//     // 绑定动态属性
//     mydata.zoom = ratio;
//   });
// });

// watch(()=>{return route.path} , ()=>{
//   nextTick(()=>{
//       setTimeout(()=>{
//         window.document.documentElement.scrollTop = 0
//       } , 0)
//   })
// })

/////退出登录
// function exit() {
//   axios({
//     method: "post",
//     url: "/house/login/outlogin",
//     headers: {
//       token: localStorage.getItem("token"),
//     },
//   }).then((res) => {
//     console.log("res.data", res.data);
//     // return
//     if (res.data.code === 1) {
//       ElMessage({
//         message: res.data.msg,
//         type: "success",
//       });
//       localStorage.clear();
//       router.push({
//         path: "/login",
//       });
//     } else {
//       //账号密码输入错误
//       ElMessage({
//         message: res.data.msg,
//         type: "error",
//       });
//     }
//   });
// }
</script>
<style>
.my-menu-box {
  width: 100%;
  border: none !important;
}
.el-drawer.ltr.open {
  width: 80% !important;
  /* 因为有些页面的样式还没有调整，所以有些页面宽度比较宽，抽屉的宽度使用百分比的话，也会因此而有的页面里面抽屉比较宽，有的页面里面抽屉比较窄，所以暂时写死成300px吧 */
  width: 300px !important;
}
</style>

<style scoped lang="scss">
// .box{
//   margin-top:300px;
// }

.header {
  width: 100%;
  // min-width: 1440px;
  height: 50px;
  // position: fixed;
  position: sticky;
  top: 0;
  // border-bottom: 1px solid #cccccc;
  background-color: #ffffff;
  z-index: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 1000;
  box-shadow: 0 0px 4px 0px #0015291f;
  background: #ffffff;
  // padding: 0px 16px;
  
   :deep(.el-icon){
     color:#333333;
     font-size:20px;
     position: absolute;
     left:16px;
     margin-top:2px;
    //  top:1px;
   }

   > p {
      font-size: 20px;
      font-weight: 400;
      letter-spacing: 1px;
      color: #333333;
      // text-align: center;
      // margin:0 auto;
      // cursor: pointer;
    }

  
}

//-------------回到顶部按钮--------------------
// :deep(.el-backtop) {
//   // border:1px solid red;
//   width: 60px;
//   height: 60px;
//   .el-icon {
//     font-size: 35px;
//     font-weight: 900;
//   }
// }

// .bottomBar{
//   position:absolute;
//   bottom:0px;
//   // z-index: 1000;
// }
</style>
